import styled from 'styled-components'
import { NavLink as NavLinkBase, Link, NavLinkProps } from 'react-router-dom'

import { device } from '../../../Styles/mediaQueries'
import { Collapsible } from 'react-materialize'

export const NavContainer = styled.nav`
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 1;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 20px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 4px 4px rgba(0, 0, 0, 0.1);

  height: auto;

  @media ${device.mobileL} {
    position: static;
    gap: 24px;
    align-items: center;
    flex-direction: row;
    width: 100%;
    box-shadow: none;
    padding-right: 0;
    background: transparent;
  }
`

export const Options = styled.button`
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  background: transparent;
  cursor: pointer;
  &:focus {
    background: transparent;
  }
`

export const InactiveLink = styled(Link)`
  opacity: 0.6;
  cursor: default;
  &:hover {
    background: transparent;
  }
`

export const StyledDropdown = styled.div`
  button {
    line-height: 64px;
  }
  margin: 0 0 0 2rem;
  .dropdown-content li {
    &:hover {
      background: transparent;
    }
  }
`

export const StyledCollapsible = styled(Collapsible)`
  position: relative;
  .collapsible {
    border: none;
    li {
      width: 100%;
    }
  }
  .collapsible-body {
    border-top: 1px solid #ddd;
    background-color: white;
    padding: 0;
    width: 100%;
  }
  .collapsible-header {
    border: none;
    padding: 1rem 0;
  }

  a {
    font-size: 1.6rem;
  }

  border: none;
  color: black;
  box-shadow: none;
  line-height: 56px;
`

export const Username = styled.button`
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  background: transparent;
  cursor: pointer;

  &:focus {
    background: transparent;
  }
`

export const OtherItems = styled.div`
  margin-top: 24px;

  @media ${device.mobileL} {
    margin-top: 0;
    margin-left: auto;
    display: flex;
    gap: 24px;
    align-items: center;
  }
`

export const NavLink = styled(
  (props: NavLinkProps & { disabled?: boolean }) => (
    <NavLinkBase
      {...props}
      activeStyle={{
        color: '#2c8ef8',
        boxShadow: 'inset 0 -2px 0 #2c8ef8',
      }}
    />
  )
)`
  font-size: 1.6rem;
  color: #3a3a3a;
  margin-bottom: -1px;

  &:hover {
    color: #2c8ef8;
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
    opacity: 0.6;
    &:hover {
      color: initial;
    }
  `}
`
